<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.order-detail')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">

          <b-row class="mb-5">
            <b-colxx xxs="12">
              <b-card class="mb-4" title="구매정보">
                <b-row>
                  <b-colxx sm="10" class="mb-2">
                    <b-form-group label-cols="1" horizontal label="주문번호">
                      <b-form-input :plaintext="true" v-model="orderNo"></b-form-input>
                    </b-form-group>
                  </b-colxx>
                  <b-colxx sm="5" class="mb-2">
                    <b-form-group label-cols="2" horizontal label="구매자명">
                      <b-form-input :plaintext="!editFlag" v-model="buyerName"></b-form-input>
                    </b-form-group>
                  </b-colxx>
                  <b-colxx sm="6" class="mb-2">
                    <b-form-group label-cols="2" horizontal label="구매자 연락처">
                      <b-form-input :plaintext="!editFlag" v-model="buyerPhone"></b-form-input>
                    </b-form-group>
                  </b-colxx>
                  <!--                  <b-colxx sm="5" class="mb-2">-->
                  <!--                    <b-form-group label-cols="2" horizontal label="수신자명">-->
                  <!--                      <b-form-input :plaintext="!editFlag" v-model="user"></b-form-input>-->
                  <!--                    </b-form-group>-->
                  <!--                  </b-colxx>-->
                  <!--                  <b-colxx sm="6" class="mb-2">-->
                  <!--                    <b-form-group label-cols="2" horizontal label="수신자 연락처">-->
                  <!--                      <b-form-input :plaintext="!editFlag" v-model="userPhone"></b-form-input>-->
                  <!--                    </b-form-group>-->
                  <!--                  </b-colxx>-->
                  <b-colxx sm="10" class="mb-2">
                    <b-form-group label-cols="1" horizontal label="결제정보">
                      <span class="form-control-paintext">
                        {{salePriceTotal | currency}}원
                        –
                        <span id="discount" style="color:blue; text-decoration-line: underline; cursor: pointer;">{{discountInfo.total | currency}}원</span>
                        –
                        {{userPointPayment | currency}}원 = {{agentPayment | currency}}원
                      </span>
                      <b-popover target="discount" placement="top" triggers="hover" v-if="discountInfo.list.length > 0">
                        <div>
                          <p v-for="(obj , idx ) in discountInfo.list">
                            {{obj.offerName}} : {{obj.discountAmount | currency}}원
                          </p>
                          <div class="separator mb-1 mt-2"></div>
                          할인 총액 : {{discountInfo.total | currency}}원
                        </div>
                      </b-popover>
                    </b-form-group>
                  </b-colxx>
                  <b-colxx sm="10" class="mb-2">
                    <b-form-group label-cols="1" horizontal label="구매일">
                      {{purchaseDate}}
                    </b-form-group>
                  </b-colxx>
                  <b-colxx sm="10" class="mb-2">
                    <b-form-group label-cols="1" horizontal label="주문상태">
                      {{orderStatus}}[{{agentPaymentMethod}}]
                    </b-form-group>
                  </b-colxx>
                  <!--                  매장관리에서는 주문상태 복원 , 구매정보 수정 일단 빼두라함 . by Danny 2020-03-18  fro Anndy -->
                  <!--                  <div style="text-align: right">-->
                  <!--                    <b-button class="mb-1" variant="primary" v-b-popover.hover.top="'취소신청 상태에서 결제취소가 아직 안되었을때 사용 가능'" @click="recoverCancel" >주문 상태 복원</b-button>-->
                  <!--                    <b-button class="mb-1" variant="primary" v-if="!editFlag" @click="editMode">구매정보 수정</b-button>-->
                  <!--                    <b-button class="mb-1" variant="success" v-if="editFlag" @click="editSave">구매정보저장</b-button>-->
                  <!--                    <b-button class="mb-1" variant="outline-danger" v-if="editFlag" @click="editCancel">수정취소</b-button>-->
                  <!--                  </div>-->
                </b-row>
              </b-card>
            </b-colxx>
          </b-row>

          <b-row class="mb-5">
            <b-colxx>
              <b-card class="mb-4" title="쿠폰내역">
                <b-table head-variant="light"
                         ref="general-table"
                         class="vuetable"
                         id="table-transition-example"
                         :items="orderItems"
                         align="center"
                         responsive=""
                         :fields="couponReserveFields"
                >
                  <template v-slot:cell(salePrice)="row">
                    {{row.item.salePrice | currency}}
                  </template>
                  <template v-slot:cell(availableTo)="row">
                    {{row.item.availableFrom}} ~ {{row.item.availableTo}}
                  </template>
                  <template v-slot:cell(issueDate)="row">
                    {{$moment( row.item.issueDate ).format('YYYY-MM-DD') }}
                  </template>
                  <template v-slot:cell(consumedDate)="row">
                    <b-button variant="outline-primary" @click="openModalCouponUseDetail(row.item)" size="xs"
                              v-if="row.item.consumedDate">
                      {{$moment( row.item.consumedDate ).format('YYYY-MM-DD')}}
                    </b-button>
                  </template>
                  <template v-slot:cell(bookingNo)="row">
                    <span @click="showBookingDetail(row.item.bookingNo)"
                          style="cursor:pointer;color:blue;">{{row.item.bookingNo}}</span>
                  </template>
                </b-table>
              </b-card>
            </b-colxx>
          </b-row>

          <b-row class="mb-5">
            <b-colxx>
              <b-card class="mb-4" title="발급내역">
                <b-row>
                  <b-colxx sm="10" class="mb-2">
                    <b-form-group label-cols="1" horizontal label="발송내역">
                      <b-form-textarea id="textarea-plaintext" readonly value=""></b-form-textarea>
                    </b-form-group>
                  </b-colxx>
                </b-row>
                <b-row>
                  <b-colxx sm="10" class="mb-2">
                    <b-form-group label-cols="1" horizontal label="발송번호">
                      <b-form-input v-model="sendPhoneNumber" style="width:15rem;float:left"></b-form-input>
                      <b-button class="mb-1 mr-1" variant="primary default" @click="sendSMS">문자 재발송</b-button>
                    </b-form-group>
                  </b-colxx>
                </b-row>
              </b-card>
            </b-colxx>
          </b-row>

          <b-row>
            <b-colxx xxs="12">
              <b-row>
                <b-col align="center">
                  <b-button variant="outline-primary" @click="()=>{this.$router.back()}">뒤로가기</b-button>
                  <b-button variant="primary" @click="partialModalShow">부분취소
                  </b-button>
                  <b-button variant="danger" @click="cancelPop">구매취소
                  </b-button>
                  <b-button variant="warning" @click="extensionExpire">유효기간연장</b-button>
                </b-col>
              </b-row>
            </b-colxx>
          </b-row>

          <partial-cancel-detail @process="partialCancel" ref="modal_partial_cancel" :data="partialCancelList"/>
          <coupon-use-detail ref="modal_coupon_use_detail" :data="selectedCoupon"/>
          <cancel-memo ref="modal_cancel_memo" title="취소사유" :data="memo" @confirm="cancelProcess"/>

          <b-modal id="bookingdetails" ref="bookingdetails" size="lg" title="예약 상태" :hide-backdrop="false"
                   :no-close-on-backdrop="true">
            <booking-details-viewer :data="bookingInfo" :checkUseFlag="false"/>

            <template slot="modal-footer">
              <b-button variant="outline-primary" @click="hideModal('bookingdetails')">닫기</b-button>
            </template>
          </b-modal>

        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>
  import {
    mapGetters
  } from "vuex";

  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import api from '../../constants/api'
  import {currencyFilter, getOrderStatusText, getAgentPaymentMethodText, alignTableCenter} from '../../utils'
  import PartialCancelDetail from './components/PartialCancelDetail'
  import CouponUseDetail from './components/CouponUseDetail'
  import BookingDetailView from "../booking/components/BookingDetailView";
  import ModalMemo from "./components/ModalMemo";

  export default {
    components: {
      'v-select': vSelect,
      'partial-cancel-detail': PartialCancelDetail,
      'coupon-use-detail': CouponUseDetail,
      'booking-details-viewer': BookingDetailView,
      'cancel-memo': ModalMemo
    },
    filters: {...currencyFilter},
    data() {
      return {
        editFlag: false,
        inHomePageOrder: true, //홈페이지예약인지 ,외부채널인지
        orderNo: this.$route.params.order_no,
        selectedCoupon: [],
        partialCancelList: [],
        buyerName: '',
        username: '',
        buyerPhone: '',
        agentPaymentMethod: '', //결제방식
        purchaseDate: null, //구매일
        orderStatus: '', //주문상태
        orderCancellable: false, //취소가능여부
        // cancellableTo : null,
        salePriceTotal: 0, //판매금액
        paymentTotal: 0,  //결제금액 ( 판매금액 - 아이템별 할인금액 )
        discounts: [], // 주문에 할인금액
        netPaymentTotal: 0, // 실결제금액( 결제금액 - 주문에 할인금액 )
        userCashPayment: 0, // 캐시
        userPointPayment: 0, // 포인트
        agentPayment: 0,  //기타결제 ( 실결제금액 - 캐시 - 포인트 )
        orderItems: [],
        memo: null, //운영자 메모
        bookingInfo: {
          bookingNo: null,
          visitorName: null,
          visitorPhone: null,
          visitorRequests: null,
          storeName: null,
          reservationDate: null,
          bookingRequestDate: null,
          bookingStatus: null,
          orderItems: [],
        },
        couponFields: [
          {key: "selected", label: "", ...alignTableCenter},
          {key: "itemNo", label: "쿠폰번호", ...alignTableCenter},
          {key: "goodsName", label: "상품명", ...alignTableCenter},
          {key: "optionName", label: "옵션명", ...alignTableCenter},
          {key: "salePrice", label: "판매가", ...alignTableCenter},
          {key: "availableTo", label: "유효기간", ...alignTableCenter},
          {key: "issueDate", label: "발급일", ...alignTableCenter},
          {key: "consumedDate", label: "사용일", ...alignTableCenter},
        ],
        sendPhoneNumber: null,
        originValue: [],
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName']),
      couponReserveFields: { //쿠폰내역 필드정의
        get: function() {
          let isReserve = false
          if(this.orderItems.length > 0) {
            isReserve = (this.orderItems[0].goodsType == "Booking" || this.orderItems[0].goodsType == "BookingCoupon") ? true : false
          }
          return isReserve ? [...this.couponFields, {
            key: "bookingNo",
            label: "예약번호", ...alignTableCenter
          }] : this.couponFields
        }
      },

      discountInfo: {  //할인목록 및 총할인액 계산
        get: function() {
          let _info = []
          let _totalDiscountAmount = 0;
          //각 아이템별 할인 목록 취합
          this.orderItems.forEach(function(value) {
            value.discounts.forEach(function(v) {
              _info.push({
                offerName: v.offerName,
                discountAmount: v.discountAmount
              });
              _totalDiscountAmount += v.discountAmount
            });
          })
          //주문에 걸린 할인 목록 취합
          this.discounts.forEach(function(v) {
            _info.push({
              offerName: v.offerName,
              discountAmount: v.discountAmount
            });
            _totalDiscountAmount += v.discountAmount
          });
          return {
            total: _totalDiscountAmount,
            list: _info
          }
        }
      },
    },

    mounted() {
      this.loadData()
    },
    watch: {},


    methods: {


      getOrderStatusText,
      getAgentPaymentMethodText,


      /** *************************************************************************************************************/
      /** 주문상세 조회 ************************************************************************************************/
      /** *************************************************************************************************************/
      loadData() {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.orderDetails)
        const params = {orderNo: this.orderNo}

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            

            let _data = res.data.data.orderDetails
            this.orderNo = _data.orderNo
            this.buyerPhone = _data.buyerPhone
            this.buyerName = _data.buyerName
            this.username = _data.username
            this.agentPaymentMethod = this.getAgentPaymentMethodText(_data.agentPaymentMethod)
            this.purchaseDate = this.$moment(_data.purchaseDate).format('YYYY-MM-DD HH:mm')
            this.orderStatus = this.getOrderStatusText(_data.orderStatus)
            this.orderCancellable = _data.orderCancellable
            this.salePriceTotal = _data.salePriceTotal
            this.paymentTotal = _data.paymentTotal
            this.discounts = _data.discounts
            this.netPaymentTotal = _data.netPaymentTotal
            this.userCashPayment = _data.userCashPayment
            this.userPointPayment = _data.userPointPayment
            this.agentPayment = _data.agentPayment
            this.orderItems = _data.orderItems
          } else {
            throw 400
          }
        }).catch(err => {
          alert('주문정보를 불러오지 못했습니다.')
          this.$router.back()
        })
      },


      /** *************************************************************************************************************/
      /** 문자 발송 ***************************************************************************************************/
      /** *************************************************************************************************************/
      sendSMS() {

      },

      /** *************************************************************************************************************/
      /** 쿠폰내역 사용일 조회 *****************************************************************************************/
      /** *************************************************************************************************************/
      openModalCouponUseDetail(item) {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.itemsUseInfo)
        const params = {
          "itemNos": [item.itemNo]
        }

        const vm = this

        this.selectedCoupon = []

        this.$http.post(reqURL, params,
          {headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}}
        ).then(res => {
          if(res.data.code === "OK") {
            const _data = res.data.data

            _data[0].transactions.forEach(function(value, index) {
              vm.selectedCoupon.push({
                'use_date': value.useDate.substr(0, 10),
                'use_store': value.storeName,
                'use_history': '사용처리'
              })
            })


            vm.$refs.modal_coupon_use_detail.open()


          } else {
            throw 400
          }
        }).catch(err => {
        })
      },


      /** *************************************************************************************************************/
      /** 부분취소 ****************************************************************************************************/
      /** *************************************************************************************************************/

      //부분취소버튼 클릭 시 부분취소 가능 아이템 설정
      partialModalShow() {

        if(this.agentPaymentMethod == "가상계좌") {
          alert('무통장입금 결제는 부분취소가 불가능 합니다.')
          return false
        }

        if(!this.inHomePageOrder) {
          alert('외부채널 구매는 부분취소를 하실수 없습니다.')
          return false
        }

        //부분취소 가능한 item list
        this.partialCancelList = []

        this.orderItems.forEach((v) => {
          if(v.cancellable) {
            this.partialCancelList.push({
              text: v.itemNo + ' ' + v.optionName + ' ' + v.salePrice,
              value: {itemNo: v.itemNo, price: v.paymentAmount}
            })
          }
        })

        this.$refs.modal_partial_cancel.open()
      },

      //부분취소 처리
      partialCancel(selectedItems) {
        let _itemNos = []
        selectedItems.forEach((v) => {
          _itemNos.push(v.itemNo)
        })
        if(confirm('부분취소 처리 하시겠습니까? ')) {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.cancelOrder)

          const params = {
            "memo": "",
            "target": {
              "orderNo": this.orderNo,
              "orderCancel": false,
              "itemsToCancel": _itemNos
            },
            "requestReason": "고객 요청 취소 처리 건"
          }


          console.log(params)
          this.$http.post(reqURL, params, {
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if(res.data.code === "OK") {
              alert('처리되었습니다.');
              this.$router.go()

            } else {
              throw 400
            }
          }).catch(err => {
          })
        }
      },

      /** *************************************************************************************************************/
      /** 주문취소 ****************************************************************************************************/
      /** *************************************************************************************************************/

      //취소사유 입력모달 열기
      cancelPop() {
        let _usedItem = false
        this.orderItems.forEach((v) => {
          if(v.consumedDate) {
            _usedItem = true
            return false
          }
        })
        if(_usedItem) {
          alert('주문건 내 사용된 쿠폰이 있습니다.')
          return false
        }

        if(!this.orderCancellable) {
          alert('주문취소가 불가능한 상태입니다.')
          return
        }

        this.$refs.modal_cancel_memo.open()
      },


      //사유 입력 받은후 구매취소
      cancelProcess(memo) {


        if(confirm('구매취소 처리 하시겠습니까? ')) {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.cancelOrder)
          const params = {
            "memo": "",
            "target": {
              "orderNo": this.orderNo,
              "orderCancel": true,
              "itemsToCancel": []
            },
            "requestReason": "고객 요청 취소 처리 건"
          }


          this.$http.post(reqURL, params, {
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if(res.data.code === "OK") {
              if(res.data.data.refundResult === 'Refunded') {
                alert('취소처리 되었습니다.')
              } else {
                alert('취소 접수가 되었습니다.')
              }
            } else {
              throw 400
            }
          }).catch(err => {

          })
        }
      },

      /** *************************************************************************************************************/
      /** 유효기간연장 *************************************************************************************************/
      /** *************************************************************************************************************/

      checkProduct() { // 상품 유효기간 체크


        if(this.orderItems[0].availableFrom === null) {
          return false
        } else return true
      },


      async extensionExpire() {  //유효기간연장
        if(this.$moment().format('YYYY-MM-DD') === this.$moment(this.purchaseDate).format('YYYY-MM-DD')) {
          alert('구매 당일에는 유효기간 연장이 불가합니다.')
          return false
        }
        const ableFlag = await this.checkProduct() // 주문한 상품의 현재 세팅된 유효기간이 From - to 면 연장 불가
        if(ableFlag) {
          alert('유효기간 연장이 불가합니다.')
          return false
        }

        if(confirm('유효기간을 연장하시겠습니까?')) {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.extendExpiryDate)
          const params = {
            orderNo: this.orderNo
          }
          this.$http.post(reqURL, params, {
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if(res.data.code === "OK") {
              alert('유효기간이 연장되었습니다.')
              this.$router.go()
            } else {
              throw 400
            }
          }).catch(err => {

          })
        }
      },


      showBookingDetail(booking_no) {  //예약상세보기
        this.$refs['bookingdetails'].show();
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.bookingDetail)
        const params = {
          bookingNo: booking_no
        }
        this.$http.post(reqURL, params,
          {headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}}
        ).then(res => {
          if(res.data.code === "OK") {
            this.bookingInfo = res.data.data.bookingDetails
          } else {
            throw 400
          }
        }).catch(err => {
        })
      },
      hideModal(id) {
        this.$refs[id].hide();
      },
    }
  }
</script>


